export default __webpack_public_path__ + "static/media/preloader.5dbf4efe.gif";